<template>
  <div>Envía correos electrónicos usando plantillas personalizados con o sin parámetros.</div>

  <p class="campaign_name">Estás en la campaña: {{ sequence?.portfolio?.name }}</p>

  <h3 class="node_subtitle">Configura tu nodo</h3>
  <a-form layout="vertical" ref="formRef" :model="formState" :rules="rules">
    <a-form-item name="channel_customer">
      <template #label>
        <div>
          <span>Identificador a utilizar</span>
        </div>
      </template>
      <a-select
        v-model:value="selectedEmailOption"
        :getPopupContainer="(triggerNode: any) => triggerNode.parentNode"
        placeholder="Seleccionar identificar"
        :disabled="disabled"
        @change="handleEmailOptionChange"
      >
        <template v-for="identifier in emailIdentifiers" :key="identifier.id">
          <a-select-option :value="'id:' + identifier.id">
            <div class="option">
              <span>{{ identifier.associate }}</span>
              <p>{{ identifier.alias }}</p>
            </div>
          </a-select-option>
          <a-select-option
            v-for="alias in getAliasesForChannel(identifier.id)"
            :key="'alias-' + alias.email"
            :value="'alias:' + identifier.id + ':' + alias.email"
          >
            <div class="option">
              <span>{{ alias.email }}</span>
              <p>{{ identifier.alias }} ({{ identifier.associate }})</p>
            </div>
          </a-select-option>
        </template>
      </a-select>
    </a-form-item>

    <h3 class="node_subtitle">Contenido del correo</h3>
    <a-form-item required name="email_subject">
      <template #label>
        <div>
          <span>Línea del asunto</span>
        </div>
      </template>
      <a-input
        v-model:value="formState.email_subject"
        placeholder="Escribir correo electrónico"
        show-count
        :maxlength="120"
        :disabled="disabled"
      />
    </a-form-item>
    <a-form-item required name="message_type">
      <template #label>
        <div>
          <span>Tipo de mensaje</span>
        </div>
      </template>
      <a-select
        @change="changeMessageType"
        @update:value="getEmailTemplates"
        :getPopupContainer="(triggerNode: any) => triggerNode.parentNode"
        v-model:value="formState.message_type"
        placeholder="Seleccionar tipo de mensaje"
        :disabled="disabled"
      >
        <a-select-option v-for="typeMessage in typesMessage" :key="typeMessage.value">
          {{ typeMessage.label }}
        </a-select-option>
      </a-select>
    </a-form-item>
    <!-- template email -->
    <div v-if="formState.message_type === SequenceTypeMessage.UseTemplate">
      <div class="card">
        <!-- <h4>Plantilla de correo</h4> -->
        <a-form-item name="email_template" required>
          <template #label>
            <div class="label">
              <span>Plantilla de correo</span>
              <a-button
                :disabled="!displayEmailTemplate || disabled"
                @click="showModalTemplate = true"
                type="link"
                class="view-template"
              >
                Previsualiza tu plantilla
              </a-button>
            </div>
          </template>
          <a-select
            v-model:value="formState.email_template"
            :placeholder="
              emailTemplates.length > 0
                ? 'Seleccionar plantilla'
                : 'No se encontraron plantillas, crea tu primera plantilla'
            "
            :getPopupContainer="(triggerNode: any) => triggerNode.parentNode"
            @change="handleEmailTemplateChange()"
            :loading="loadingTemplate"
            :disabled="disabled || emailTemplates.length == 0"
            :option-label-prop="'customLabel'"
          >
            <a-select-opt-group v-if="emailTemplatesWithParameters.length > 0" label="Plantillas con parámetros">
              <a-select-option
                v-for="item in emailTemplatesWithParameters"
                :key="item.id"
                :disabled="item.status !== 1"
                :customLabel="`${item.name} (con parámetros)`"
              >
                {{ item.name }}
              </a-select-option>
            </a-select-opt-group>
            <a-select-opt-group  v-if="emailTemplatesWithoutParameters.length > 0" label="Plantillas sin parámetros">
              <a-select-option
                v-for="item in emailTemplatesWithoutParameters"
                :key="item.id"
                :disabled="item.status !== 1"
                :customLabel="`${item.name} (sin parámetros)`"
              >
                {{ item.name }}
              </a-select-option>
            </a-select-opt-group>
          </a-select>
        </a-form-item>

        <div v-if="currentEmailTemplate?.parameters?.length > 0">
          <template-parameters :disabled="disabled" v-model:values="formState.parameters" 
            :template="currentEmailTemplate" :portfolioId="sequence?.portfolio?.id" />
        </div>
      </div>
    </div>
    <!-- redact email -->
    <div v-if="formState.message_type === SequenceTypeMessage.ComposeMessage">
      <a-form-item
        required
        name="email_message"
        label="Cuerpo del correo electrónico"
        style="width: 100%"
      >
        <a-button class="btn-email" primary @click="showModalRedact = true" :disabled="disabled"
          >Editar cuerpo de correo</a-button
        >
      </a-form-item>
    </div>

    <h3 class="node_subtitle">Define el siguiente paso</h3>

    <ActionPicker
      v-if="formState.action"
      v-model:value="formState.action"
      :disabled="disabled"
      :isMultichannel="true"
      :sequence="sequence"
    />
  </a-form>

  <a-modal
    :title="`Plantilla ${templateTitle}`"
    class="modal-template"
    v-model:open="showModalTemplate"
    width="775px"
    :bodyStyle="{ height: '480px', justifyContent: 'center', display: 'flex' }"
    centered
  >
    <div class="container__template">
      <iframe
        :srcdoc="displayEmailTemplate"
        class="template_email"
        id="template_email"
        title="template_email"
        ref="iframe"
        style="border: none; width: 625px; height: 480px; margin: 0"
        @load="scaleIframeContent"
      ></iframe>
    </div>
    <template #footer>
      <a-divider />
      <a-button @click="showModalTemplate = false" class="btn-large">
        Cerrar previsualización
      </a-button>
    </template>
  </a-modal>
  <a-modal
    title="Cuerpo del correo electrónico"
    class="modal-template"
    v-model:open="showModalRedact"
    width="780px"
    :bodyStyle="{ minHeight: '460px' }"
    centered
    :maskClosable="false"
    @close="closeRedact"
  >
    <div class="container-template">
      <div class="card email">
        <p class="message--info">
          Escriba el texto de su correo electrónico. Tenga en cuenta que no podra reutilizarlo para
          futuros correos si deseas crear tu planilla.
        </p>
        <div class="editor">
          <EditorComponent v-model="formState.email_message" />
          <InputActionButtons v-model:files="formState.attachments" @select-emoji="handleAddEmoji" multiple :validatePerType="false" />
        </div>
      </div>
    </div>
    <template #footer>
      <a-divider />
      <a-button @click="closeRedact"> Cancelar </a-button>
      <a-button
        @click="
          emailMessage = formState.email_message;
          showModalRedact = false;
        "
        type="primary"
        :disabled="disabled"
      >
        Guardar cambios
      </a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, inject, Ref, watch, toRaw } from "vue";
import { FormInstance } from "ant-design-vue";

import { Sequence, SequenceNode, SequenceTypeMessage, SequenceStatus } from "@/@types/flows/sequences";

import ActionPicker from "@/app/flows/sequences/components/pickers/ActionPicker.vue";
import { fetchAllChannelsCustomersByPortfolio, fetchSendAsAliases } from "@/app/channels/services";
import { ChannelType } from "@/app/shared/utils/enums";
import { fetchEmailTemplates } from "@/app/workspace/services";
import EditorComponent from "@/app/emails/components/editor/Editor.vue";
import InputActionButtons from "@/app/shared/components/buttons/InputActionButtons.vue";
import TemplateParameters from "@/app/flows/sequences/components/sections/drawerForms/TemplateParameters.vue";

import _ from "lodash";

const props = defineProps<{ node: SequenceNode; disabled: boolean; sequence: Sequence }>();

const formRef = ref<FormInstance>();

const nodeSequence = () => {
  return {
    channel_customer: props.node?.channel_customer?.id,
    send_as_alias_identifier: props.node?.send_as_alias_identifier || null,
    email_subject: props.node?.email_subject,
    email_message: props.node?.email_message || "",
    email_template: props.node?.email_template?.id,
    attachments: props.node?.attachments_public_url || [],
    action: props.node.action,
    message_type: props.node?.email_message
      ? SequenceTypeMessage.ComposeMessage
      : props.node?.email_template
      ? SequenceTypeMessage.UseTemplate
      : null,
    parameters: props.node?.parameters ?? [],
  };
};

const formState = ref<Partial<SequenceNode>>(nodeSequence());

watch(
  () => props.node,
  () => {
    formState.value = nodeSequence();
  }
);

const rules = {
  channel_customer: [{ required: true, message: "Campo requerido" }],
  email_subject: [
    { required: true, message: "Campo requerido" },
    {
      validator: (_, value) => {
        if (value?.length > 0 && value.trim() === "") {
          return Promise.reject(new Error("Campo no puede contener solo espacios"));
        }
        return Promise.resolve();
      },
      message: "Campo no puede contener solo espacios",
    },
  ],
  email_message: [{ required: true, message: "Campo requerido" }],
  email_template: [{ required: true, message: "Campo requerido" }],
  message_type: [{ required: true, message: "Campo requerido" }],
  parameters: [{ required: true }],
};

const saveDisabled = inject("saveDisabled") as Ref<Boolean>;

// const emailIdentifiers = ref<ChannelCustomer[]>([]);
const emailIdentifiers = computed(() => {
  return props.sequence?.channels_customers?.filter((el) => el.channel?.id == ChannelType.Email);
});
const aliasesByIdentifier = ref<Record<number, any[]>>({});
const selectedEmailOption = ref<string | null>(null);

const getAliasesForChannel = (channelCustomerId: number) => {
  const list = [...(aliasesByIdentifier.value[channelCustomerId] || [])];
  const node = props.node;
  if (props.sequence?.status === SequenceStatus.Active && node && node.channel_customer?.id === channelCustomerId && node.send_as_alias_identifier) {
    const exists = list.some((alias) => alias.email === node.send_as_alias_identifier);
    if (!exists) {
      list.push({
        id: -1,
        email: node.send_as_alias_identifier,
      });
    }
  }
  return list;
};

const preloadAliasesForAllIdentifiers = async () => {
  const identifiers = emailIdentifiers.value || [];
  const results = await Promise.allSettled(
    identifiers.map(async (item) => {
      const data = await fetchSendAsAliases(item.id);
      const list = Array.isArray(data) ? data : (data?.results || []);
      return { id: item.id, aliases: list };
    })
  );
  const aliasMap: Record<number, any[]> = {};
  for (const r of results) {
    if (r.status === 'fulfilled') {
      aliasMap[r.value.id] = r.value.aliases;
    }
  }
  aliasesByIdentifier.value = aliasMap;
};

const handleEmailOptionChange = (val: string | null) => {
  formState.value.send_as_alias_identifier = null;

  if (!val) {
    formState.value.channel_customer = null;
    return;
  }

  if (val.startsWith('alias:')) {
    const parts = val.split(':');
    const channelId = parseInt(parts[1]);
    const aliasEmail = parts.slice(2).join(':');
    formState.value.channel_customer = channelId;
    formState.value.send_as_alias_identifier = aliasEmail;
  } else {
    formState.value.channel_customer = parseInt(val.replace('id:', ''));
  }
};

const initSelectedEmailOption = () => {
  const node = props.node;
  if (!node?.channel_customer) {
    selectedEmailOption.value = null;
    return;
  }
  const channelId = node.channel_customer.id;
  if (node.send_as_alias_identifier) {
    if (props.sequence?.status !== SequenceStatus.Active) {
      const activeAliases = aliasesByIdentifier.value[channelId] || [];
      const isValid = activeAliases.some((alias: any) => alias.email === node.send_as_alias_identifier);
      if (!isValid) {
        selectedEmailOption.value = null;
        formState.value.channel_customer = null;
        formState.value.send_as_alias_identifier = null;
        saveDisabled.value = false;
        return;
      }
    }
    selectedEmailOption.value = 'alias:' + channelId + ':' + node.send_as_alias_identifier;
  } else {
    selectedEmailOption.value = 'id:' + channelId;
  }
};

const typesMessage = ref([
  { value: SequenceTypeMessage.UseTemplate, label: "Usar plantilla" },
  { value: SequenceTypeMessage.ComposeMessage, label: "Redactar mensaje" },
]);
const emailMessage = ref(props.node?.email_message);

// const attachments = ref<string | File | undefined>(undefined);
const emailTemplates = ref<any[]>([]);
const displayEmailTemplate = ref("");

const showModalTemplate = ref<boolean>(false);
const showModalRedact = ref<boolean>(false);
const loadingTemplate = ref(false);
const templateTitle = ref("");
const iframe = ref();

let previousValue = _.cloneDeep(toRaw(formState.value));

const emailTemplatesWithParameters = computed(() =>
  emailTemplates.value.filter((el) => el.parameters?.length > 0)
);

const emailTemplatesWithoutParameters = computed(() =>
  emailTemplates.value.filter((el) => el.parameters == null)
);

const getValidatedFormState = async () => {
  await formRef.value?.validateFields();

  return formState.value;
};

const fetchEmailIdentifiers = async () => {
  emailIdentifiers.value = await fetchAllChannelsCustomersByPortfolio(
    props.sequence?.portfolio?.id
  );
  await preloadAliasesForAllIdentifiers();
  initSelectedEmailOption();
};

const changeMessageType = async () => {
  formState.value.email_message = "";
  formState.value.email_template = null;
  formState.value.attachments = [];
  emailMessage.value = null;
  displayEmailTemplate.value = "";
};

const getEmailTemplates = async (value?: number | null) => {
  loadingTemplate.value = true;
  if (value) formState.value.email_template = undefined;
  emailTemplates.value = await fetchEmailTemplates(true, props.sequence?.portfolio?.id);
  loadingTemplate.value = false;
};

const currentEmailTemplate = computed(() => {
  return emailTemplates.value?.find((item) => item?.id == formState.value.email_template);
});

watch(
  () => currentEmailTemplate.value,
  (value) => {
    if (!value?.parameters || value?.parameters?.length == 0) {
      formState.value.parameters = undefined;
    }
  }
);

const handleEmailTemplateChange = () => {
  const currentTemplate = currentEmailTemplate.value;
  displayEmailTemplate.value = currentTemplate.template.replace(
    /<body style="margin: [^;]+;/,
    '<body style="'
  );
  displayEmailTemplate.value = displayEmailTemplate.value.replace(
    /<a\s+([^>]*\s)?href="([^"]*)"(?![^>]*target)/g,
    '<a $1href="$2" target="_blank"'
  );

  templateTitle.value = currentTemplate.name;
};

const scaleIframeContent = () => {
  const scale = 0.8;
  iframe.value.contentWindow.document.body.style.zoom = scale;
};

const handleAddEmoji = (emoji: any) => {
  const lastClosingTagIndex = formState.value?.email_message?.lastIndexOf("</p>");

  const inputText = formState.value.email_message;

  formState.value.email_message =
    inputText?.slice(0, lastClosingTagIndex) + emoji + inputText?.slice(lastClosingTagIndex);
};

const closeRedact = () => {
  formState.value.email_message = emailMessage;
  showModalRedact.value = false;
};

watch(
  () => formState.value,
  (value) => {
    if (value && JSON.stringify(previousValue) != JSON.stringify(value)) {
      saveDisabled.value = false;
    }
  },
  { deep: true, immediate: true }
);

watch(
  () => props.sequence?.status,
  (newStatus) => {
    if (newStatus !== undefined) {
      initSelectedEmailOption();
    }
  }
);

defineExpose({ getValidatedFormState });

onMounted(async () => {
  await fetchEmailIdentifiers();
  await getEmailTemplates();
  if (formState.value.email_template) await handleEmailTemplateChange();
});
</script>

<style scoped lang="sass">
p
  color: $text-primary
  margin-bottom: 24px

h2
  color: $text-primary
  font-size: 16px
  font-weight: 600
  margin-bottom: 12px

.picker
  width: 100%

:deep(.ant-form-item-label > label)
  width: 100%
:deep(.ant-form-item-label > label > div)
  display: flex
  justify-content: space-between
  align-items: center
  width: 100%

.ant-input-show-count-suffix::after
  position: absolute
  margin: 0 !important
  font-size: 12px
  bottom: 0
  right: 5px

.btn-email
  border: 1px solid #1677ff
  color: #1677ff
  width: 100%

.btn-large
  width: 350px

.container
  &__template
    display: flex
    width: 100%
    justify-content: center

:global(.editor .ck-content)
  min-height: 280px !important

:global(.ck.ck-editor__main)
  max-height: min(calc(100vh - 10px), 600px)
  overflow-y: auto
// :deep(.editor .ck-content)
//   min-height: 150px !important

.campaign_name
  margin-top: 8px
  margin-bottom: 16px
  font-size: 13px
  font-style: italic
  color: #1677FF

.node_subtitle
  margin-bottom: 16px
  font-size: 1.1em

:deep(.ant-form-item-label)
  width: 100%
:deep(label[for="form_item_email_template"])
  width: 100%
.label
  width: 100%
  display: flex
  justify-content: space-between

.option
  p
    font-size: 12px
    color: rgba(0, 0, 0, 0.45)
    margin: 0
</style>
